import React from "react";
import { BarChart3, ShieldCheck, Clock, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const featuresData = [{
  title: "What is MTD ITSA?",
  description: <>
      Making Tax Digital (MTD) is a government initiative that changes the way 
      businesses and individuals keep records and submit tax information.<br /><br /> 
      From April 2026, MTD for Income Tax Self Assessment (MTD ITSA) will apply to:<br /> 
      – Self‑employed individuals<br /> 
      – Landlords<br /> 
      – Partnerships (later date)<br /><br /> 
      If your annual business or property income is over £50,000, you’ll need to 
      follow MTD rules. From April 2027, those earning over £30,000 will also be included. 
    </>,
  icon: BarChart3,
  linkText: "View analytics",
  href: "#analytics"
}, {
  title: "What Will Change?",
  description: <>
      Instead of one annual tax return, you will:<br /><br /> 
      - Keep digital records of income and expenses<br /><br /> 
      - Send quarterly updates to HMRC using approved software<br /><br /> 
      - Submit an end-of-period statement and final declaration<br /><br /> 
      This means more regular reporting, but less end-of-year stress.
    </>,
  icon: ShieldCheck,
  linkText: "Read security policy",
  href: "/PrivacyPolicyPage"
}, {
  title: "Deadlines",
  description: <>
      These are the standard update periods and deadlines, which line up with the tax year (6 April to 5 April).<br /><br /> 
      Update period (Update deadline)<br /><br />  
      6 April to 5 July 2026<br />  
      (7 August 2026)<br /> 
      6 April to 5 October 2026<br />  
      (7 November 2026)<br /> 
      6 November to 5 January 2027<br />  
      (7 February 2027)<br /> 
      6 February to 5 April 2027<br />  
      (7 May 2027)
   </>,
  icon: Clock,
  linkText: "Contact support",
  href: "/TeamAndContactPage"
}];
export default function Features() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="features" ref={ref} className="bg-background ![padding:64px_0px_128px_0px]">
      <div className="container mx-auto px-6">
        <div className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {featuresData.map((feature, i) => <Card key={i} data-index={i} className="text-card-foreground gap-6 border-muted rounded-sm p-8 flex flex-col h-full shadow-none transition-colors !bg-[hsl(210,14%,89%)] hover:shadow-none">
              <CardHeader className="p-0 mb-6 space-y-0">
                <div className="mb-6">
                  <feature.icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-[28px] font-semibold font-sans text-foreground leading-[1.4] tracking-[-0.2px]">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-0 flex-grow flex flex-col justify-between">
                <p className="text-base leading-[1.6] mb-8 !text-[hsl(210,9%,31%)]">
                  {feature.description}
                </p>
                <div>
                  
                </div>
              </CardContent>
            </Card>)}
        </div>
     <div className="mt-12"> <img src="https://sloane.co.uk/wp-content/uploads/2026/02/mtd-timeline.png" alt="MTD graphic" className="max-w-none rounded-lg shadow-md !w-[820px] !h-[510px] ![margin:0px_0px_0px_180px]" /> </div>
      
      </div>
        </section>;
}